import { useMocks } from '../../shared/env';
import type { CustomPayRunGateway } from './CustomPayRunGateway';
import { HttpCustomPayRunGateway } from './HttpCustomPayRunGateway';
import { MockCustomPayRunGateway } from './MockCustomPayRunGateway';

export const customPayRunGateway: CustomPayRunGateway = useMocks ? new MockCustomPayRunGateway() : new HttpCustomPayRunGateway();

/** TEST-ONLY (mock mode): clears the mock gateway's in-memory runs. A no-op against the real gateway. */
export function resetMockCustomPayRunGatewayForTests(): void {
  if (customPayRunGateway instanceof MockCustomPayRunGateway) customPayRunGateway.resetForTests();
}
export type { CustomPayRunGateway } from './CustomPayRunGateway';
